import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle, BatteryWarning, Wallet, ListX } from 'lucide-react';
export function Problem() {
  const pains = [{
    icon: <BatteryWarning className="w-6 h-6 text-tactical-cta" data-id="element-195" />,
    text: 'Te sientes cansado sin haber hecho ejercicio.'
  }, {
    icon: <Wallet className="w-6 h-6 text-tactical-cta" data-id="element-196" />,
    text: 'Tienes dinero que se escapa en gastos invisibles.'
  }, {
    icon: <ListX className="w-6 h-6 text-tactical-cta" data-id="element-197" />,
    text: 'Tu lista de sueños sigue siendo exactamente igual a la del año pasado.'
  }];
  return <section className="py-24 bg-tactical-dark border-b border-tactical-border" data-id="element-198">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-199">
        <FadeIn data-id="element-200">
          <div className="text-center mb-16" data-id="element-201">
            <h2 className="text-4xl sm:text-5xl font-bold uppercase mb-6" data-id="element-202">
              No tienes un problema de identidad.
              <br data-id="element-203" />
              <span className="text-tactical-cta" data-id="element-204">
                Tienes un problema de ejecución.
              </span>
            </h2>
            <p className="text-xl text-zinc-400 max-w-3xl mx-auto" data-id="element-205">
              El gran error de la mayoría es creer que necesitan "más
              motivación" o "un mejor plan". La realidad es que el cerebro
              humano está programado para protegerte del esfuerzo, y tu mente es
              experta en fabricar excusas lógicas para que te quedes donde
              estás.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-206">
          {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} className="bg-tactical-panel p-6 border border-tactical-border flex flex-col items-center text-center group hover:border-tactical-cta/50 transition-colors" data-id="element-207">
              <div className="w-12 h-12 bg-zinc-950 border border-zinc-800 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-208">
                {pain.icon}
              </div>
              <p className="text-zinc-300 font-medium" data-id="element-209">{pain.text}</p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-210">
          <div className="bg-tactical-accent/10 border border-tactical-accent/30 p-6 sm:p-8 text-center" data-id="element-211">
            <div className="flex justify-center mb-4" data-id="element-212">
              <AlertTriangle className="w-8 h-8 text-tactical-accent" data-id="element-213" />
            </div>
            <p className="text-xl sm:text-2xl font-oswald uppercase tracking-wide text-zinc-100" data-id="element-214">
              Estás operando con un software de "supervivencia" cuando necesitas
              uno de <span className="text-tactical-accent" data-id="element-215">"ataque"</span>.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}